<script>
    import { store, store_offer } from '../../Store.svelte';
    import HeaderMin from '../../components/HeaderMin.svelte';
    import AddressModal from '../../components/common/AddressModal.svelte';
    import LegalsComponentSky from '../../components/comparator/components/LegalsComponentSky.svelte';
    import Preloader from '../../components/Preloader.svelte';
    import OfferMain from '../../components/offer/OfferMain.svelte';

    let sky_prepago = [];
    let sky_pospago = [];
    let isPrepago = true;
    $store.requestedServices.isSky = true;

    const loadData = () => {
        const { loadedOffer } = $store_offer;
        const { offers } = loadedOffer;

        sky_prepago = offers.offnet_sky;
    };

    $: if ($store_offer.loadedOffer.offers) {
        loadData();
    }

    const toggleSelection = (prepago) => {
        isPrepago = prepago;
    };

    const popupClick = () => {};
</script>

<HeaderMin />
<main>
    {#if $store_offer.loadedOffer == null || $store_offer.loadedOffer.offers == null}
        <div class="pure-g full-width">
            <div class="pure-u-1">
                <div class="text-center">
                    <h2 class="text-fs-23 fw-semibold base-text m-b-5">
                        Obteniendo paquetes disponibles
                    </h2>
                    <p class="text-fs-13 m-b-15">
                        {$store.requestedAddress.addressString}
                        {$store.requestedAddress.postalCode}
                    </p>
                    <p class="text-fs-13">
                        <a
                            href="#/"
                            on:click|preventDefault={popupClick}
                            class="popup base-text underline"
                            data-custom-open="modal-cobertura"
                            >Cambiar dirección</a
                        >
                    </p>
                </div>
                <div class="pure-g">
                    <div class="pure-u-1">
                        <div class="text-center"><Preloader /></div>
                    </div>
                </div>
            </div>
        </div>
    {:else}
        <div class="comparator-container-sky">
            {#if $store.requestedAddress.postalCode != null && $store.requestedAddress.postalCode.length > 0}
                <div class="comparator-address">
                    <p class="header fw-semibold">Paquetes disponibles en:</p>
                    <div class="content">
                        <p class="text">
                            {$store.requestedAddress.addressString}
                            {$store.requestedAddress.postalCode}
                        </p>
                        <p class="link">
                            <a
                                href="#/"
                                on:click|preventDefault={popupClick}
                                class="popup blue-dark-text"
                                data-custom-open="modal-cobertura"
                                >Cambiar dirección</a
                            >
                        </p>
                    </div>
                </div>
            {:else}
                <div class="comparator-address">
                    <p class="header">No has ingresado tu dirección</p>
                    <div class="content">
                        <p class="text">
                            Ingresa tu dirección para validar las ofertas que se
                            encuentran disponibles para ti
                        </p>
                        <p class="link">
                            <a
                                href="#/"
                                on:click|preventDefault={popupClick}
                                class="popup blue-dark-text"
                                data-custom-open="modal-cobertura"
                                >Ingresar dirección</a
                            >
                        </p>
                    </div>
                </div>
            {/if}
            <OfferMain
                useSky={true}
                shouldDisplaySkyPrepago={true}
                plansObject={{
                    plans: sky_prepago,
                    category: 'offnet_sky',
                }}
            />
            <LegalsComponentSky {isPrepago} />
            <div>
                <div class="modal" id="modal-cobertura" aria-hidden="true">
                    <AddressModal locationPath="residencial" />
                </div>
            </div>
        </div>
    {/if}
</main>
